function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#f76c6c;}.b{fill:#05192f;font-size:24px;font-family:SourceSansPro-SemiBold, Source Sans Pro;font-weight:600;}"));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-163.958 -304)"
}, /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M9.676,4.99a1.052,1.052,0,0,1,1.495,1.48l-7.58,7.58H28.6A1.053,1.053,0,0,1,29.665,15.1,1.066,1.066,0,0,1,28.6,16.157H3.591l7.58,7.565a1.073,1.073,0,0,1,0,1.495,1.047,1.047,0,0,1-1.495,0L.3,15.843a1.055,1.055,0,0,1,0-1.48Z",
  transform: "translate(163.959 304.324)"
}), /*#__PURE__*/React.createElement("text", {
  className: "b",
  transform: "translate(217 328)"
}, /*#__PURE__*/React.createElement("tspan", {
  x: 0,
  y: 0
}, "Back to Forecast")));

function SvgBackArrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 223.042,
    height: 31,
    viewBox: "0 0 223.042 31",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackArrow);
export default __webpack_public_path__ + "static/media/backArrow.ec082f5b.svg";
export { ForwardRef as ReactComponent };